import { FOOTER_LINKS } from '../constants/footer';
import LendoIcon from './LendoIcon';
import LendoOpeningHours from './LendoOpeningHours';
import LendoCollapsibleList from './LendoCollapsibleList';
import LendoFooterSocials from './LendoFooterSocials';
import kundeserviceImage from '../assets/kundeservice_2025.png';
import { openCookieSettings } from '../utils/usercentrics';

export function LendoFooterMobile() {
  const currentYear = new Date().getFullYear();

  const handleLinkClick = (link: any) => {
    if (link.action === 'openCookieSettings') {
      openCookieSettings();
    } else if (link.link) {
      window.location.href = link.link;
    }
  };

  return (
    <div className="lendo-footer-mobile">
      <LendoIcon className="logo" name="logo" size="30px" />
      <div className="mb-4 flex justify-center">
        <img src={kundeserviceImage} width="80px" alt="Kundeservice bilde" />
      </div>
      <div className="contact-action" style={{ marginBottom: '8px' }}>
        <LendoIcon name="icon/phone-icon" size="24px" />
        <a href="tel:22007070">22 00 70 70</a>
      </div>
      <div className="contact-action" style={{ marginBottom: '1rem' }}>
        <LendoIcon name="icon/mail" size="24px" />
        <a href="mailto:kundeservice@lendo.no">kundeservice@lendo.no</a>
      </div>
      <LendoOpeningHours />

      <div className="collapsible-sections">
        <LendoCollapsibleList title="Søk om lån">
          <div className="section-links">
            {FOOTER_LINKS.loan.map((link) => (
              <div key={link.title} className="link">
                <a href={link.link} className="lendo-link">
                  {link.title}
                </a>
              </div>
            ))}
          </div>
        </LendoCollapsibleList>

        <LendoCollapsibleList title="Få oversikt">
          <div className="section-links">
            {FOOTER_LINKS.overview.map((link) => (
              <div key={link.title} className="link">
                <a href={link.link} className="lendo-link">
                  {link.title}
                </a>
              </div>
            ))}
          </div>
        </LendoCollapsibleList>

        <LendoCollapsibleList title="Lendo">
          <div className="section-links">
            {FOOTER_LINKS.lendo.map((link) => (
              <div key={link.title} className="link">
                {link.action ? (
                  <button
                    onClick={() => handleLinkClick(link)}
                    className="lendo-link"
                    style={{
                      background: 'none',
                      border: 'none',
                      padding: 0,
                      cursor: 'pointer',
                    }}
                  >
                    {link.title}
                  </button>
                ) : (
                  <a href={link.link} className="lendo-link">
                    {link.title}
                  </a>
                )}
              </div>
            ))}
          </div>
        </LendoCollapsibleList>
      </div>

      <div className="company-info">
        <div>&copy; {currentYear} Lendo AS</div>
        <div style={{ margin: '4px 0' }}>Org. nr 997 523 814</div>
        <div>Hagegata 22, 0653 OSLO</div>
        <LendoFooterSocials />
      </div>
    </div>
  );
}
